module.exports = require('./helpers/bundle-url').getBundleURL('gnX1Z') + "logo.c5857b8b.svg";